export default {
  auth: () => import("/home/boristane/boristane/zirp/apps/web/app/layouts/auth.vue"),
  dashboard: () => import("/home/boristane/boristane/zirp/apps/web/app/layouts/dashboard.vue"),
  default: () => import("/home/boristane/boristane/zirp/apps/web/app/layouts/default.vue")
}